<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
	<Page
		v-if="estate && site && siteId == site.id"
		:icon="'bi-pin-map'"
		:title="site.name || 'Unnamed (please edit woodland site details to add name)'"
		:back="page.back"
		:breadcrumbs="page.breadcrumbs"
		:actions="page.actions" @action="onAction">
		<template #body>
			<div class="container-fluid">
				<ModalSiteUpdate :element-id="'updateSiteModal_'+site.id" :site="site"/>
				<p class="px-3">
					You have {{ site.woodland_surveys.length }} {{ assessmentsAsText }} for this site.
				</p>
				<div v-show="pwaStore.version==2" id="accordionFlushSiteInfo" class="accordion accordion-flush mb-3 mt-2">
					<div class="accordion-item">
						<h2 id="flush-headingSiteInfo" class="accordion-header">
							<button
								class="accordion-button collapsible collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSiteInfo" aria-expanded="false"
								aria-controls="flush-collapseSiteInfo">
								<i class="bi-info-circle me-2"/>
								Info
							</button>
						</h2>
						<div
							id="flush-collapseSiteInfo" class="accordion-collapse collapse"
							aria-labelledby="flush-headingSiteInfo"
							data-bs-parent="#accordionFlushSiteInfo">
							<div class="accordion-body">
								<p>
									This is the site level of the Woodland Condition Assessment app.
									It is recommended that you use a desktop/laptop here although you can
									also use it from a mobile. From here you can:
									<ul>
										<li>
											Set plot markers for you Assessments in the on the Site Map
										</li>
										<li>
											Create new Assessments by clicking in the 'Add Assessment' box
										</li>
										<li>
											View all previous Assessments
										</li>
										<li>
											Edit and update unsubmitted Assessments
										</li>
										<li>
											Access reports for submitted Assessments
										</li>
									</ul>
								</p>
								<p>
									Before you get started with a new Assessment it is recommended that you
									place your proposed survey plots on the Site Map. Click the '+ Add new
									plot marker(s)' button and then click on the map where you propose to
									carry out plot level surveys. When you have finished click Finish and
									save plot markers to confirm these proposed plots. These plot locations
									will be available to you when you start an Assessment in the Plot Survey
									tab where you can use the markers and your live location to navigate to
									the proposed location.
								</p>
								<!-- <p>
									Here you can see the assessments you have created for this site.
								</p>
								<p>
									Use the site map to place plot markers. A 10m plot is then shown, to scale, at this location.
									You can then use the map within your {{ trans('global.what_we_call_whole_thing') }}
									to navigate to these locations when beginning a new plot {{ trans('global.what_we_call_plots_and_walk') }} for this site.
								</p>
								<p>
									The colour of the {{ trans('global.what_we_call_whole_thing') }}'s symbol corresponds to its marker on the site map.
								</p> -->
							</div>
						</div>
					</div>
				</div>
				<div v-show="pwaStore.version==2" id="siteMapAccordion" class="accordion">
					<div
						id="siteMap"
						class="accordion-item"
						name="siteMap_accordion_item">
						<h2
							id="heading_siteMap"
							class="accordion-header">
							<button
								class="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								aria-expanded="false"
								data-bs-target="#collapse_siteMap"
								aria-controls="collapse_siteMap">
								<i class="bi-map me-2"/>Site map
							</button>
						</h2>
						<div
							id="collapse_siteMap"
							class="accordion-collapse collapse p-0"
							aria-labelledby="heading_siteMap"
							data-bs-parent="#siteAccordion">
							<div v-if="site" class="accordion-body p-0">
								<MapWithMarkers
									v-if="markerNames && keyColours && coordinates"
									:plot-markers="site.plot_markers"
									:coordinates="coordinates"
									:names="markerNames"
									:center="center ? center : [0,0]"
									:markers-editable="true"
									:key-colours="keyColours"
									:show-live-location="false"
									:show-create-plot-button="false"
									:plot-surveys="allPlotSurveys"
									@save-plot-markers="savePlotMarkers"
									@delete-plot-marker="deletePlotMarker"
									@edit-plot-marker="editPlotMarker"/>
							</div>
						</div>
					</div>
				</div>
				<div v-if="site.woodland_surveys" class="row">
					<CardSurvey
						v-for="(survey,index) in site.woodland_surveys.sort(createCompareFn('assessment_date', 'asc'))" :key="index"
						:survey="survey"
						:site-id="site.id"
						:estate-id="estate.id"
						:client-id="clientId"
						:site-name="''"
						:key-colour="safeColours[index%safeColours.length]"
					/>

					<!-- Button trigger modal: ADD SITE -->
					<div id="card_add" class="col-xl-3 col-sm-6 col-12 g-4 h-100 card-group">
						<div class="card">
							<div
								class="card-body text-center" type="button" data-bs-toggle="modal" :data-bs-target="'#addSurveyModal_'+site.id">
								<div class="media">
									<div class="media-body text-left">
										<h4><i class="bi-clipboard-plus" style="font-size: larger;"/></h4>
									</div>
								</div>
							</div>
							<div class="card-footer text-center">
								Add {{ trans('global.what_we_call_whole_thing') }}
							</div>
						</div>
						<ModalSurveyAdd :site="site" :element-id="'addSurveyModal_'+site.id" :estate-id="estateId" :client-id="clientId"/>
					</div>
				</div>
			</div>
		</template>
	</Page>
	<Page v-else>
		<template #body>
			Something went wrong!
		</template>
	</Page>
</template>

<script lang="ts" setup>
	import Page from "@/views/layouts/Page.vue";
	import { useRouter } from "vue-router";
	import { computed, reactive } from "vue";
	import ModalSiteUpdate from "@/views/pages/private/dashboard/partials/ModalSiteUpdate.vue";
	import ModalSurveyAdd from "@/views/pages/private/dashboard/partials/ModalSurveyAdd.vue";
	import { useAuthStore } from "@/stores/auth";
	import CardSurvey from "@/views/pages/private/dashboard/partials/CardSurvey.vue";
	import { createCompareFn } from "@/modules/utils";
	import { useSiteStore } from "@/stores/site";
	import { usePlotMarkerStore } from "@/stores/plot_marker";
	import type { Client } from "@/types/client";
	import type { Estate } from "@/types/estate";
	import type { Site } from "@/types/site";
	import { trans } from "@/helpers/i18n";
	import MapWithMarkers from "@/views/pages/private/dashboard/MapWithMarkers.vue";
	import { siteCentre, siteSurveyPlotCoordinates, siteSurveyMarkerNames, safeColours } from "@/modules/woodlandSurvey";
	import type { PlotMarker } from "@/types/plot_marker";
	import { v4 as uuidv4 } from "uuid";
	import { usePwaStore } from "@/stores/pwa";
	import type { PlotSurvey } from "@/types/survey";

	const props = defineProps<{
		siteId: string,
		estateId: string,
		clientId: string
	}>();

	const authStore = useAuthStore();
	const siteStore = useSiteStore();
	const plotMarkerStore = usePlotMarkerStore();
	const pwaStore = usePwaStore();
	const router = useRouter();

	const client = computed<Client | undefined>(() => {
		if (!authStore.user) return undefined;
		return authStore.user.clients.find((x: any) => x.id == props.clientId);
	});
	const estate = computed<Estate | undefined>(() => {
		if (!client.value) return undefined;
		return client.value.estates.find((x: any) => x.id == props.estateId);
	});
	const site = computed<Site | undefined>(() => {
		if (!estate.value) return undefined;
		return estate.value.sites.find((x: any) => x.id == props.siteId);
	});

	const page = reactive({
		id: "site_info_" + site.value?.id,
		title: site.value?.name,
		back: "/estate/" + estate.value?.id + "/" + client.value?.id,
		filters: false,
		breadcrumbs: authStore?.user?.type != "owner" ? [
			{
				name: client.value?.name,
				to: "/client/" + client.value?.id,
				icon: "bi-person-vcard"

			},
			{
				name: estate.value?.name,
				to: "/estate/" + estate.value?.id + "/" + client.value?.id,
				icon: "bi-map"

			},
			{
				name: site.value?.name,
				active: true,
				icon: "bi-pin-map"
			}
		] : [
			{
				name: site.value?.name,
				active: true,
				icon: "bi-pin-map"
			}],
		actions: [
			{
				id: "delete",
				name: "Delete Site",
				icon: "bi-trash",
				theme: "none",
				type: "slim-button"
			},
			{
				id: "update",
				name: "Edit Details",
				icon: "bi-pencil",
				theme: "none",
				type: "modal",
				data_bs_target: "#updateSiteModal_" + site.value?.id
			}
		]
	});

	const center = computed(() => {
		if (site.value) return siteCentre(site.value);
		return null;
	});

	const allPlotSurveys = computed(() => {
		if (!site.value || site.value === undefined) return [];
		let X:Array<PlotSurvey> = [];
		for (const ws of site.value.woodland_surveys) {
			if (ws?.plot_surveys) X.push(...ws.plot_surveys);
			else console.log("plot surveys or survey didnt exist");
		}
		return X;
	});

	function onAction (data: any) {
		switch (data.action.id) {
		case "delete":
			deleteSite();
			break;
		}
	}
	const assessmentsAsText = computed(() => {
		return trans("global.what_we_call_whole_thing") +
			(site.value?.woodland_surveys.length == 1 ? "" : "s");
	});

	const keyColours = computed(() => {
		if (!site.value) return null;
		const numColours = site.value.woodland_surveys.length;
		if (numColours > safeColours.length) numColours == safeColours.length;
		return safeColours.slice(0, numColours);

	});
	const coordinates = computed(() => {
		if (!site.value) return null;
		return siteSurveyPlotCoordinates(site.value);
	});
	const markerNames = computed(() => {
		if (!site.value) return;
		return siteSurveyMarkerNames(site.value);
	});
	async function addPlotMarker (marker: Array<any>) {
		if (!site.value) return;
		const pm: PlotMarker = {
			id: uuidv4(),
			site_id: site.value.id,
			longitude: marker[0],
			latitude: marker[1],
			created_at: new Date().toISOString().slice(0, 19),//.replace("T", " "),
			updated_at: new Date().toISOString().slice(0, 19),//.replace("T", " ")
		};
		plotMarkerStore.store(pm);
	}
	async function savePlotMarkers (markers: Array<any>) {
		for (const marker of markers)
			addPlotMarker(marker);
	}
	async function deletePlotMarker (pm: PlotMarker) {
		if (!site.value) return;
		pm.deleted_at = new Date().toISOString();//.slice(0, 19).replace("T", " ")[0];
		await plotMarkerStore.destroy(pm);
	}
	async function editPlotMarker (uuid: string, lon: number, lat: number) {
		if (!site.value) return;
		let pm = site.value.plot_markers.filter((m) => m.id == uuid)[0];
		pm.longitude = lon;
		pm.latitude = lat;
		await plotMarkerStore.update(pm);
	}

	// Delete the site and redirect the window to the parent estate
	async function deleteSite () {
		if (!site.value) throw new Error("SiteInfo.deleteSite does not have a site to delete");
		if (!estate.value) throw new Error("SiteInfo.deleteSite does not have an associated estate");
		if (!client.value) throw new Error("SiteInfo.deleteDite does not have an associated site");
		if (confirm("Are you sure you want to to delete this site? All linked surveys will be deleted as well.")) {
			try {
				await siteStore.destroy(site.value);
			} finally {
				router.push({
					name: "estateInfo",
					params: { estateId: estate.value.id, clientId: client.value.id }
				});
			}
		}
	}
	document.addEventListener("shown.bs.collapse", (e) => {
		const el = e.target as HTMLElement;
		el.scrollIntoView({ behavior: "smooth", block: "start" });
	});
</script>
